import React from 'react';
import { ComponentFrame } from "../../frame/ComponentFrame";
import { SectionHeader } from "../section-header/SectionHeader";
import { ItemGroup } from "../item-group/ItemGroup";
import { ListLayout } from "../layout/ListLayout";
import { SolutionItem } from "../item/SolutionItem";
import { connect } from 'react-redux';

class SolutionsContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      solutions: this.parseSolutions(this.props)
    };
  }

  componentWillReceiveProps(nextProps){
    this.setState({ solutions: this.parseSolutions(nextProps) });

  }

  parseSolutions(props){
    if( props.solutions === undefined || typeof props.solutions.map !== 'function') return [];

    return props
        .solutions
        .map((solution, i) => {
          solution.reverse = i % 2 === 0;
          return solution;
        });
  }

  render (){
    return (
      <ComponentFrame tag="section"
                      header={
                        <SectionHeader align="center"
                                       color="#F4F6F7"
                                       title="Solution Areas"
                                       subtitle="Obelux Led low-intensity obstruction lights are fully compliant with civil aviation authority regulations. Photocell (Day/Night) sensor can be integrated into the light unit, which offers also flashing feature for the lights."/>
                      }>
        <ItemGroup layout={ ListLayout }
                   layoutAttributes={{ noGutters: true }}
                   item={ SolutionItem }
                   itemStyle="solution-style" data={this.state.solutions}/>
      </ComponentFrame>
    );
  }
}

export const Solutions = connect(
  state => ({
    solutions: ( state.resolve.data && state.resolve.data.solutions ) || []
  })
)(SolutionsContainer);



// WEBPACK FOOTER //
// ./src/components/solutions/Solutions.js